import Box from "@mui/material/Box";
import {FC, useCallback, useContext, useEffect} from "react";
import {makeStyles} from "tss-react/mui";
import {Modal} from "@buildwitt/shapeshift-common/v2/modal";
import {Button, LinearProgress, Typography} from "@mui/material";
import {INotificationSeverity, NotificationContext, useApi} from "@buildwitt/shapeshift-identity";
import {cohortBaseUrl} from "../../../constants";

interface IProps {
	open: boolean,
	onClose: (reload?: boolean) => void,
	playlistId: number,
	selected: number[]
}

const useStyles = makeStyles()((theme) => ({
	adminBulkUnEnrollmentModal: {
		padding: theme.spacing(3),
		display: "flex",
		gap: theme.spacing(2),
		flexDirection: "column"
	}
}));

export const AdminBulkPlaylistCompletionModal: FC<IProps> = ({open, selected, playlistId, onClose}) => {
	const {classes} = useStyles();
	const {notify} = useContext(NotificationContext);
	const [completionResponse, submitCompletionApi] = useApi<any>() //> any to do

	const handleSubmitCompletionEnroll = useCallback(() => {
		if(!open || completionResponse.isLoading)
			return;

		submitCompletionApi({
			url: `${cohortBaseUrl}/group/${playlistId}/users/complete`,
			method: "PUT",
			data: {
				users: selected
			}
		})
	}, [playlistId, open, completionResponse.isLoading])

	useEffect(() => {
		if(completionResponse.statusCode === 200){
			notify("", "Successfully updated users completions", INotificationSeverity.success, 5000)
			onClose(true)
		}
		else if(completionResponse.statusCode){
			notify("", "Failed to set users completion", INotificationSeverity.error, 5000)
			onClose()
		}
	}, [completionResponse])

	return (
		<Modal
			open={open}
			footerButtons={[
				<Button key={1} onClick={() => onClose()}>CANCEL</Button>,
				<Button key={2} onClick={() => handleSubmitCompletionEnroll()}>CONFIRM</Button>
			]}
			onClose={() => onClose()}
			aria-labelledby="modal-modal-title"
			title="Confirm Bulk Completion"
			aria-describedby="modal-modal-description"
		>
			<Box className={classes.adminBulkUnEnrollmentModal}>
				<Typography variant="h5">Confirm Bulk Playlist Completion</Typography>
				<Typography>
					<li>[{selected.length}] users selected</li>
				</Typography>
				{completionResponse.isLoading && <LinearProgress />}
			</Box>
		</Modal>
	);
}